import { API_ROOT } from './.env'
const PROFILES = 'profiles/'
import {buildUri} from './index'

// Search in profiles

export const get = (params) => API_ROOT + PROFILES + buildUri(params);

export const searchUsers = (str) => API_ROOT + PROFILES + '?search=' + str

// about
export const basicInfo = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}`

// contact
export const getContacts = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}?fields=addresses,phones,emails`

export const phones = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}/phones`

export const emails = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}/emails`

export const addresses = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}/addresses`

//citizenships
export const getCitizenships = (userId) => API_ROOT + `${PROFILES}${userId}?fields=citizenships{country,type}`

export const citizenships = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}/citizenships`

// employments
export const employments = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}/employments`

// educations
export const educations = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}/education`

// skills
export const getSkills = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}/skills?fields=certifications,professionalGroups`

export const skills = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}/skills`

export const certifications = (userId, skillId) => {
    let skillsURI = skills(userId)
    return skillsURI + `/${skillId}/certifications`
}

export const groups = (userId, skillId) => {
    let skillsURI = skills(userId)
    return skillsURI + `/${skillId}/groups`
}

// social-media
export const socialMedia = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}/social-media`

// memberships
export const memberships = (entityId, userId) => API_ROOT + `entities/${entityId}/${PROFILES}${userId}/memberships`

export const userNotes = (userId) => API_ROOT + `${PROFILES}${userId}/notes`


// EXPORTS FUNCTIONS AS DEFAULT OBJECT
export default {
    basicInfo,
    citizenships,
    phones,
    emails,
    addresses,
    employments,
    educations,
    skills,
    certifications,
    groups,
    socialMedia,
    memberships
}



// WEBPACK FOOTER //
// ./src/api/profile.js